import { ConfirmationDialog } from "../../common/ConfirmationDialog";
import React from "react";
import { useTranslation } from "hhn-commons";

type UnstarAllModalProps = {
  isOpen: boolean;
  onClose: () => void;
  unstarAll: () => void;
};

export const UnstarAllModal = ({
  isOpen,
  onClose,
  unstarAll,
}: UnstarAllModalProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "starredMessages" });

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onClose={onClose}
      confirmationTitle={tNs("unstarAll")}
      confirmationMessage={tNs("unstarAllConfirmation")}
      confirmationButtonText={t("buttonLabels.ok")}
      onConfirmationAction={unstarAll}
    />
  );
};
